module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAP1JREFUeNpi/PfvHwMjIyMDEIj8//8/Gcj2B7IVGCDgIVBsC1BsNpD9CshmYABpADKMgPjCf9zgChCbgdSCNEgBOdfRFNwB4tvoYkC1siANTUiC34H8AiDmheIsoNg3mCSQ3wlyzkUkDWtB1iJjoNhyJPmrTEDPSDMgwAsQAQoEaECAwDMkeTGQhndIAl5ArIHEVwFifyT+F5C1E9A89wiIe4C4G4gfoMnNB7lRG4g//ScMfgANtwFpAOEqIjRMgcUDCLMB8WZcKoFyJ4FYAFkDLALPYFEPijB1mDr0MFcC4ktIih8AxY2Q1TCgRxQQKwAVHgXZBmTrossDBBgArJnv6Pl23H0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/icons/pos.png
// module id = KkSE
// module chunks = 18